import { makeImmutable } from "../core";
export class OrderingPolicy {
    constructor(params) {
        this.maxOrderValue = params.maxOrderValue;
        this.deliveryInTotal = params.deliveryInTotal;
        this.enableCoupons = params.enableCoupons;
        this.enableFod = params.enableFod;
        this.cashRequiresExactAmount = params.cashRequiresExactAmount;
        this.enableMarketingConsents = params.enableMarketingConsents;
        this.serviceFeeSettings = params.serviceFeeSettings;
        this.country = params.country;
        makeImmutable(this);
    }
    validate({ value: priceToTest }) {
        if (this.maxOrderValue) {
            return priceToTest.leq(this.maxOrderValue);
        }
        return true;
    }
}
